export enum AnalyticsEvent {
  Login = 'login',
}

class AnalyticsService {
  pushDataLayerEvent(event: AnalyticsEvent, data?: Record<string, any>): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event,
      ...data,
    });
  }
}

export const analyticsService = new AnalyticsService();
